import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { EvaluatorDetailPage } from "@/features/evaluator-operations/detail/evaluator-detail-page";
import { EVALUATOR_DETAIL_VIEW_VALUES } from "@/features/evaluator-operations/types";

export const Route = createFileRoute("/evaluators/$evaluatorId")({
  validateSearch: z.object({
    view: z.enum(EVALUATOR_DETAIL_VIEW_VALUES).catch("overview"),
    runId: z.string().optional(),
    version: z.string().optional(),
    stage: z.string().optional(),
    timeWindow: z.string().optional(),
  }),
  component: () => (
    <PermissionGuard module="evaluators">
      <EvaluatorDetailPage />
    </PermissionGuard>
  ),
});
